import AppRegistrationIcon from '@mui/icons-material/AppRegistration'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import PeopleIcon from '@mui/icons-material/People'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import { Typography } from '@mui/material'
import { ReactNode, useState } from 'react'

import { Page } from '../../components'
import ListingByShop from '../../components/CustomerFeedback/ListingByShop'
import CustomerList from '../../components/Customers/CustomerList'
import IntakeRequestList from '../../components/Intake/Listing'
import {
  ElevatedTab,
  ElevatedTabPanel,
  ElevatedTabs
} from '../../components/SharedUI/ElevatedTab'
import VehicleList from '../../components/Vehicles/VehicleList'
import VehicleReminderList from '../../components/Vehicles/VehicleReminderList'

// Using a separate component here doesn't work. The MUI Tabs component seems to
// expect its direct children to be Tab components.
const getCrmElevatedTab: (
  icon: ReactNode,
  label: string,
  value: number
) => ReactNode = (icon, label, value) => (
  <ElevatedTab
    label={
      <>
        {icon}
        <Typography variant="subtitle1">{label}</Typography>
      </>
    }
    value={value}
  />
)

export default function CustomerRelationshipManagement() {
  const [tab, setTab] = useState<number>(0)

  return (
    <Page title="Customer Relationship Management" testId="customersPage">
      <ElevatedTabs value={tab} onChange={(e, v) => setTab(v)}>
        {getCrmElevatedTab(<PeopleIcon sx={{ pr: 1 }} />, 'Customers', 0)}
        {getCrmElevatedTab(<DirectionsCarIcon sx={{ pr: 1 }} />, 'Vehicles', 1)}
        {getCrmElevatedTab(
          <NotificationsActiveIcon sx={{ pr: 1 }} />,
          'Reminders',
          2
        )}
        {getCrmElevatedTab(
          <AppRegistrationIcon sx={{ pr: 1 }} />,
          'Registrations',
          3
        )}
        {getCrmElevatedTab(<ThumbUpIcon sx={{ pr: 1 }} />, 'Reviews', 4)}
      </ElevatedTabs>
      <ElevatedTabPanel sx={{ p: 0 }}>
        {tab === 0 && <CustomerList />}
        {tab === 1 && <VehicleList />}
        {tab === 2 && <VehicleReminderList />}
        {tab === 3 && <IntakeRequestList />}
        {tab === 4 && <ListingByShop />}
      </ElevatedTabPanel>
    </Page>
  )
}
